import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { PageShell } from '@/components/layout/PageShell'
import { DocumentManagementListPage } from './DocumentManagementListPage'
import { TermsConditionsListPage } from './TermsConditionsListPage'

type DocSection = 'terms' | 'service'

function sectionFromPathname(pathname: string): DocSection {
  if (
    pathname.startsWith('/gdpr-consent') ||
    pathname.includes('/document-management/service')
  ) {
    return 'service'
  }
  return 'terms'
}

/** Configuration → Document Management (Angular `/terms-and-conditions` / `/gdpr-consent/gdpr-document`). */
export function DocumentManagementPage() {
  const { pathname } = useLocation()
  const activeSection = useMemo(
    () => sectionFromPathname(pathname),
    [pathname],
  )
  const pageTitle =
    activeSection === 'service' ? 'SERVICE AGREEMENT' : 'TERMS & CONDITIONS'

  return (
    <PageShell
      title={pageTitle}
      contentClassName="!w-full !min-w-0 !max-w-none !px-3 !py-4 sm:!px-6 sm:!py-6"
    >
      <div className="min-w-0">
        {activeSection === 'service' ? (
          <DocumentManagementListPage embedded />
        ) : (
          <TermsConditionsListPage />
        )}
      </div>
    </PageShell>
  )
}
